import React, { useState, useEffect, useCallback } from 'react';
import {
  C, S, Badge, StatusBadge, FormField, ErrList, StatCard,
  PageHeader, FilterBar, DataTable, Modal, FormGrid,
  useToast, useConfirm, useCRUD,
} from '../../components/inventoryShared';
import {
  categoryController, subCategoryController, brandController,
  unitController, productController, warehouseController,
  locationController, supplierController, purchaseOrderController,
  purchaseReturnController, stockInController, stockOutController,
  stockTransferController, stockAdjustmentController,
  stockController, reportController,
} from '../../controllers/inventoryController';
import {
  Tag, Layers, Boxes, Settings, Package, BarChart3,
  PackageCheck, TrendingDown, ArrowLeftRight, ClipboardList,
  Users, ShoppingCart, RotateCcw, Warehouse, MapPin,
  AlertTriangle, Receipt, FileText, QrCode, Plus,
  Edit2, Trash2, Eye, Download, RefreshCw, CheckCircle,
  XCircle, Truck, ChevronDown, ChevronUp, Search,
} from 'lucide-react';
// ─────────────────────────────────────────────────────────────────────────────
// 16. LOW STOCK ALERTS PAGE
// ─────────────────────────────────────────────────────────────────────────────
export const LowStockPage = ({ companyId }) => {
  const [data, setData]       = useState([]);
  const [loading, setLoading] = useState(false);
  const { show, ToastEl }     = useToast();

  const fetchData = async () => {
    setLoading(true);
    const res = await productController.getLowStock(companyId);
    if (res.success) setData(res.data);
    else show(res.message, 'error');
    setLoading(false);
  };

  useEffect(() => { fetchData(); }, [companyId]);

  return (
    <div style={S.page}>
      {ToastEl}
      <PageHeader title="Low Stock Alerts" subtitle="Products below minimum stock level" Icon={AlertTriangle} color={C.warning}
        action={<button style={S.btnSec} onClick={fetchData}><RefreshCw size={15}/> Refresh</button>} />
      <div style={S.card}>
        {loading ? <div style={S.center}>Loading...</div> : (
          <div style={{ overflowX:'auto' }}>
            <table style={S.table}>
              <thead><tr>{['Product','SKU','Category','Current Stock','Min Stock','Reorder Qty','Warehouse','Status'].map(h=><th key={h} style={S.th}>{h}</th>)}</tr></thead>
              <tbody>
                {data.map((p,i)=>(
                  <tr key={p.id||i} style={{ background: p.currentStock<=0 ? '#fff5f5' : '#fffbeb' }}>
                    <td style={S.td}><div style={{ fontWeight:700 }}>{p.name}</div></td>
                    <td style={S.td}><span style={{ fontFamily:'monospace', fontSize:12 }}>{p.sku||'—'}</span></td>
                    <td style={S.td}>{p.categoryName||'—'}</td>
                    <td style={S.td}><span style={{ fontWeight:800, color: p.currentStock<=0 ? C.danger : C.warning, fontSize:15 }}>{p.currentStock}</span></td>
                    <td style={S.td}>{p.minStock}</td>
                    <td style={S.td}>{p.reorderQty||'—'}</td>
                    <td style={S.td}>{p.warehouseName||'—'}</td>
                    <td style={S.td}><Badge color={p.currentStock<=0?C.danger:C.warning} bg={p.currentStock<=0?'#fee2e2':'#fef3c7'} dot>{p.currentStock<=0?'Out of Stock':'Low Stock'}</Badge></td>
                  </tr>
                ))}
                {!data.length && <tr><td colSpan={8}><div style={S.center}>✅ All products have sufficient stock</div></td></tr>}
              </tbody>
            </table>
          </div>
        )}
      </div>
    </div>
  );
};
export default LowStockPage;